import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router'
import { ComponentExt } from 'util/reactExt'
import { Tag, Row, Col, Modal } from 'antd'
import Breadcrumb from 'components/Breadcrumb'
import Article from './article'
import VideoPanel from '../../shared/VideoPanel'
import CollectPanel from '../../shared/CollectPanel'
import CardLayout from 'components/layout/CardLayout'
import GuessLayout from 'components/layout/GuessLayout'
import Card from 'components/Card'
import { randomColor } from 'util/utils'
import styles from './index.scss'

// 枚举记录课程类型
enum DataType {
  video = '1000101',
  text = '1000102',
  audio = '1000103',
}
interface Props extends RouteComponentProps<any> {}
// 远端返回课程详情结构
type TVideo = {
  id: number
  content: string
  title: string
  publish_date: number
  labels: object[]
  view_count: number
  courseware_url: string
  homework_id: number
  article_desc: string
  img_url: string
  recommand_count: number
  password: number
  praise_count: number
  has_praise: number
  course_time: number
  random: string
}
// 收藏量与状态
type Collect = {
  collectCount: number
  hasCollect: 0 | 1
}
interface State {
  id: number
  info: TVideo
  colors: string[]
  collect: Collect
  collectModal: boolean
  loading: boolean
  guess: any[]
  related: any[]
  type?: DataType
}

class CourseDetail extends ComponentExt<Props, State> {
  private timer // 计时器，课程计时用

  constructor(props) {
    super(props)
    this.state = {
      id: undefined,
      info: {} as TVideo,
      colors: [],
      collectModal: false,
      collect: {
        collectCount: 0,
        hasCollect: 0,
      },
      loading: false,
      guess: [],
      related: [],
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      match: {
        params: { id },
      },
    } = nextProps
    return {
      ...prevState,
      id,
    }
  }

  componentDidMount() {
    const { id } = this.state
    const { search } = this.props.location
    const type = new URLSearchParams(search).get('type')
    this.fetchContent(id, type)
    this.fetchGuess(id)
    this.fetchRelated(id)
    this.setState({
      type: type as DataType,
    })
  }

  componentDidUpdate(_, prevState) {
    const { id } = this.state
    const { search } = this.props.location
    const type = new URLSearchParams(search).get('type')
    if (this.state.id !== prevState.id) {
      this.fetchContent(id, type)
      this.fetchGuess(id)
      this.fetchRelated(id)
      this.setState({
        type: type as DataType,
      })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  get breadcrumbs() {
    const breadcrumbs = new URLSearchParams(this.props.location.search).get(
      'breadcrumbs',
    )

    return breadcrumbs
      ? breadcrumbs
          .split(',')
          .concat('详情')
          .map(b => {
            return { name: b, url: '' }
          })
      : [{ name: '首页', url: '/home' }, { name: '详情', url: '' }]
  }

  get getCategoryId() {
    return new URLSearchParams(this.props.location.search).get('categoryid')
  }

  get getTopicId() {
    return new URLSearchParams(this.props.location.search).get('topicid')
  }

  async fetchGuess(id) {
    // 获取猜你喜欢数据
    const categoryId = Number(this.getCategoryId)
    const topicId = Number(this.getTopicId)
    try {
      const data = await this.api.article.guess(id, categoryId, topicId)
      this.setState({
        guess: data,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async fetchRelated(id) {
    // 获取相关视频数据
    try {
      const data = await this.api.article.related(id)
      this.setState({
        related: data,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async fetchCollectSave(cid, id) {
    // 收藏内容
    const { search } = this.props.location
    const ttype = new URLSearchParams(search).get('type')
    const { type } = this.state
    try {
      const { msg } = await this.api.collect.collect(cid, id, type)
      this.$message.success(msg || '收藏成功')
      this.setState({
        loading: false,
        collectModal: false,
      })
      this.fetchContent(id, ttype)
    } catch (err) {
      this.$message.error('错误')
    }
  }

  async fetchCollectCancel(id) {
    // 取消收藏
    const { search } = this.props.location
    const ttype = new URLSearchParams(search).get('type')
    const { type } = this.state
    try {
      const data = await this.api.collect.cancelFavorite(id, type)
      this.fetchContent(id, ttype)
      this.$message.success(data || '取消成功')
    } catch (err) {
      this.$message.error('操作错误')
      console.error(err)
    }
  }

  async likeAnswer(id) {
    // 视频点赞
    const { search } = this.props.location
    const type = new URLSearchParams(search).get('type')
    try {
      await this.api.article.likeArticle(id)
      console.log('点赞成功')
    } catch (err) {
      this.$message.error(err.message)
      this.fetchContent(id, type)
    }
  }

  async unlikeAnswer(id) {
    // 视频取消点赞
    const { search } = this.props.location
    const type = new URLSearchParams(search).get('type')
    try {
      await this.api.article.unlikeArticle(id)
      console.log('取消点赞成功')
    } catch (err) {
      this.$message.error(err.message)
      this.fetchContent(id, type)
    }
  }

  async fetchContent(id, type?) {
    // 获取视频内容
    try {
      const { data } = await this.api.article.getArticleDetail(id)
      const nstate = {
        info: data,
        colors: randomColor((data.labels && data.labels.length) || 0),
        collect: {
          collectCount: data.collect.collect_count,
          hasCollect: data.collect.has_collect,
        },
      }
      this.setState(nstate)
    } catch (err) {
      history.back()
    }
  }

  async studying() {
    // 视频时间记录
    clearTimeout(this.timer)
    this.timer = setTimeout(async () => {
      const { id, random } = this.state.info
      await this.api.article.statistics(id, random)
      this.studying()
    }, 60000)
  }

  activeRequest(fn, type) {
    return (String(type).slice(0, 4) === '1100'
      ? this.api.course
      : this.api.article)[fn]
  }

  toDetail(id, type) {
    // const { history } = this.props
    // history.push(`/course/${id}?type=${type}`)
    window.open(`#/course/${id}?type=${type}`)
  }

  handleCollect = () => {
    switch (this.state.collect.hasCollect) {
      case 0:
        this.setState({
          collectModal: true,
        })
        break
      case 1:
        this.fetchCollectCancel(this.state.id)
        break
    }
  }

  cancelModal = () => this.setState({ collectModal: false })
  handleConfirm = val => {
    this.setState({
      loading: true,
    })
    this.fetchCollectSave(val, this.state.id)
  }

  onlike = () => {
    const info = this.state.info,
      id = this.state.id
    switch (info.has_praise) {
      case 0:
        info.has_praise = 1
        info.praise_count = Number(info.praise_count) + 1
        this.likeAnswer(id)
        break
      case 1:
        info.has_praise = 0
        info.praise_count = Number(info.praise_count) - 1
        this.unlikeAnswer(id)
        break
    }
    this.setState({ info })
  }

  videoRender() {
    const {
      info,
      colors,
      collect,
      collectModal,
      guess,
      related,
      type,
    } = this.state
    const tagRender = (arr, color) => {
      return (
        arr &&
        arr.map(({ id, label_name }, idx) => (
          <Tag key={`tag-${id}`} color={color[idx]}>
            {label_name}
          </Tag>
        ))
      )
    }

    const modalRender = () => (
      <Modal
        title="收藏视频"
        visible={collectModal}
        onCancel={this.cancelModal}
        footer={null}
        style={{ top: '30%' }}
        bodyStyle={{ padding: 0 }}
      >
        <CollectPanel
          loading={this.state.loading}
          onConfirm={this.handleConfirm}
        />
      </Modal>
    )
    return (
      <>
        <div className={styles.safe}>
          <Breadcrumb data={this.breadcrumbs} />
        </div>
        <div className={styles.safe}>
          <Row gutter={20}>
            <Col span={18}>
              <div style={{ marginBottom: 22 }}>
                <VideoPanel
                  // type="m3u8"
                  id={info.id}
                  src={info.content}
                  img={info.img_url}
                  title={info.title}
                  time={info.publish_date}
                  courseTime={info.course_time}
                  tags={tagRender(info.labels, colors)}
                  people={info.view_count}
                  link={info.courseware_url}
                  collect={collect}
                  praise={{
                    hasPraise: info.has_praise as 0 | 1,
                    count: info.praise_count,
                  }}
                  type={type}
                  onLike={this.onlike}
                  onCollect={this.handleCollect}
                  onPlay={() => this.studying()}
                />
              </div>
              <CardLayout title="课程简介">
                {info.password ? (
                  <>
                    <p>解锁密码：{info.password}</p>
                    <br />
                  </>
                ) : null}
                <div
                  dangerouslySetInnerHTML={{
                    __html: info.article_desc,
                  }}
                />
              </CardLayout>
              <CardLayout
                style={{
                  marginTop: 16,
                }}
                title="相关课程"
              >
                <div className={styles.relate}>
                  {related &&
                    related.map(
                      (
                        {
                          id,
                          title,
                          img_url,
                          view_count,
                          course_time,
                          type: _type,
                        },
                        idx,
                      ) => (
                        <Card
                          key={id || idx}
                          dataType={type}
                          cover={img_url}
                          title={title}
                          watch={view_count}
                          time={course_time}
                          bodyStyle={{
                            backgroundColor: '#F5F5F5',
                          }}
                          onClick={() => this.toDetail(id, _type)}
                        />
                      ),
                    )}
                </div>
              </CardLayout>
            </Col>
            <Col span={6}>
              <GuessLayout title="猜你喜欢">
                {guess &&
                  guess.map(
                    (
                      {
                        id,
                        title,
                        img_url,
                        view_count,
                        course_time,
                        type: _type,
                      },
                      idx,
                    ) => (
                      <Card
                        key={id || idx}
                        dataType={_type}
                        cover={img_url}
                        title={title}
                        watch={view_count}
                        time={course_time}
                        bodyStyle={{
                          backgroundColor: '#F5F5F5',
                        }}
                        onClick={() => this.toDetail(id, _type)}
                      />
                    ),
                  )}
              </GuessLayout>
            </Col>
          </Row>
          {modalRender()}
        </div>
      </>
    )
  }

  articleRender() {
    const { info, colors, id, guess, collect, related } = this.state
    return (
      <>
        <Article
          id={id}
          content={info}
          color={colors}
          guess={guess}
          related={related}
          praise={{
            hasPraise: info.has_praise as 0 | 1,
            count: info.praise_count,
          }}
          collect={collect}
          articleLike={this.onlike}
          articleCollect={this.handleCollect}
          history={this.props.history}
        />
        <Modal
          title="收藏视频"
          visible={this.state.collectModal}
          onCancel={this.cancelModal}
          footer={null}
          style={{ top: '30%' }}
          bodyStyle={{ padding: 0 }}
        >
          <CollectPanel
            loading={this.state.loading}
            onConfirm={this.handleConfirm}
          />
        </Modal>
      </>
    )
  }

  render() {
    const { type } = this.state
    return type === DataType.text ? this.articleRender() : this.videoRender()
  }
}

export default withRouter(CourseDetail)
